import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PERSONA_HOME, usePersona } from '../../contexts/PersonaContext';
import { getAuthToken, isTokenExpired } from '../../utils/authHelpers';

const DashboardRedirect = () => {
  const navigate = useNavigate();
  const { activePersona } = usePersona();

  useEffect(() => {
    const token = getAuthToken();
    if (!token || isTokenExpired(token)) {
      navigate('/login', { replace: true });
      return;
    }
    navigate(PERSONA_HOME[activePersona] || '/profile-selector', { replace: true });
  }, [activePersona, navigate]);

  return null;
};

export default DashboardRedirect;
